export const HSE_TERMS = [
  {
    key: 'fatality',
    label: 'Fatality',
    definition:
      'A work-related incident that results in the death of an employee. It is the most severe type of incident and requires immediate investigation and reporting.',
  },
  {
    key: 'equipment_property_damage',
    label: 'Equipment / Property Damage',
    definition:
      'Any damage to equipment, tools, or property occurring during work activities, whether caused by an accident or negligence.',
  },
  {
    key: 'first_aid_cases',
    label: 'First Aid Cases',
    definition:
      'Emergency treatment of an illness or injury to maintain life, ease pain, and prevent deterioration of the patient\'s condition until professional medical help can be obtained.',
  },
  {
    key: 'medical_treatment_cases',
    label: 'Medical Treatment Cases (MTC)',
    definition:
      'A recordable incident involving injury or illness that has required management and care beyond first aid, but is not severe enough to be a reportable fatality or lost work day case.',
  },
  {
    key: 'occupational_illness',
    label: 'Occupational Illness',
    definition:
      'A condition resulting from exposure in a workplace to a physical, chemical, or biological agent to the extent that normal physiological mechanisms are affected and the worker\'s health is impaired.',
  },
  {
    key: 'traffic_vehicle_accident',
    label: 'Traffic / Vehicle Accident',
    definition:
      'An undesirable or unfortunate event involving a vehicle during work activities that results in harm, injury, damage, or loss.',
  },
  {
    key: 'fire_incident',
    label: 'Fire Incident',
    definition:
      'An undesirable or unfortunate event involving fire in the workplace that occurs unintentionally and may result in injury, damage, or loss.',
  },
  {
    key: 'lost_time_injury_ill_health',
    label: 'Lost Time Injury / Ill-health',
    definition:
      'A work-related injury or illness that results in a fatality, permanent disability, or time lost from work, even for one day or shift.',
  },
  {
    key: 'number_of_lost_days',
    label: 'Number of Lost Days',
    definition:
      'The total number of workdays lost due to work-related injuries or illnesses. It is used as a key factor in calculating the Severity Rate — the average number of lost days per accident.',
  },
  {
    key: 'environment_incident',
    label: 'Environment Incident',
    definition:
      'An event that may cause harm or potential harm to an environmental receptor, such as air, water, land, wildlife, or local habitat.',
  },
  {
    key: 'security_incident',
    label: 'Security Incident',
    definition:
      'An event that leads to a violation of an organization\'s security policies and puts sensitive data at risk of exposure.',
  },
] as const;

export type HseTermKey = (typeof HSE_TERMS)[number]['key'];
